import axios from "axios";
let medidas = null;
let referencedImageId = "";
let countMedida = 0;
let enabledElement = "";
let viewPortId = "viewport-0";
let startProgressBar = null;

export default function getMedidasSalvas(StartProgressBar) {
  startProgressBar = StartProgressBar;
  try {
    if (medidas === null) {
      medidas = [];
      const servico = `${window.config.dataSources[0].configuration['wadoRoot']}/studies`;
      let studyUid =
        location.search.replace('?StudyInstanceUIDs=', "")
          .replace('&acessoportal=1', "");
      axios.get(`${servico}/${studyUid}/medida`)
        .then(resp => {
          medidas = resp.data;
          if (medidas.length > 0) {
            startProgressBar(true);
            let cacheSize = 0;
            const interval = setInterval(() => { // AGUARDAR CARREGAMENTO DAS IMAGENS
              const getCacheSize = cornerstone.cache.getCacheSize();
              if (getCacheSize === cacheSize) {
                clearInterval(interval);
                medidas.length === 1 ? adicionarUmaMedidaSalva() : checarMedidasEmSeriesDiferentes();
              }
              cacheSize = getCacheSize;
            }, 500);
          }
        })
        .catch(error => {
          console.error(`Não foi possível obter medidas: ${error}`);
          startProgressBar(false);
        })
    }
  } catch (error) {
    console.error(`Não foi posssível obter medidas: ${error}`);
    startProgressBar(false);
  }
}

function addAnnotation(medida) {
  enabledElement = cornerstoneTools.state.enabledElements[0];
  cornerstoneTools.annotation.state.addAnnotation(medida, enabledElement);
  try {
    const btnOk = document.getElementById('boxNotification').getElementsByTagName('button')[2];
    if (btnOk)
      btnOk.click();
  } catch (ex) { }

  if (countMedida > 0)
    adicionarMedidasEmSeriesDiferentes();
}

function adicionarUmaMedidaSalva() {
  addAnnotation(medidas[0]);
  startProgressBar(false);
}

function checarMedidasEmSeriesDiferentes() {
  const arrReferencedImageId = [...new Map(medidas.map(item => [item.metadata.referencedImageId, item.metadata.referencedImageId])).values()];
  arrReferencedImageId.length === 1 ? adicionarMedidasSomenteEmUmaSerie() : adicionarMedidasEmSeriesDiferentes();
}

function adicionarMedidasSomenteEmUmaSerie() {
  medidas.forEach(medida => {
    addAnnotation(medida);
    startProgressBar(false);
  });
}

function adicionarMedidasEmSeriesDiferentes() {
  if (countMedida === medidas.length) {
    retornarFocoNaPrimeiraSerie();
  } else {
    const medida = medidas[countMedida];
    const dataReferencedImageId = medida.metadata.referencedImageId;
    checarImagemDaMesmaSerie(medida.metadata.referencedImageId);
    if (referencedImageId === "" || referencedImageId === dataReferencedImageId) {
      aguardarCarregamentoDaSerie(medida, dataReferencedImageId);
    } else {
      setTimeout(() => {
        viewPortId = viewPortId = "viewport-0" ? "viewport-1" : "viewport-0";
        focarNaSerie(dataReferencedImageId); // FOCO NA PRÓXIMA SÉRIE
        aguardarCarregamentoDaSerie(medida, dataReferencedImageId);
      }, 1000);
    }
  }
}

function checarImagemDaMesmaSerie(metadataReferencedImageId) {
  if (enabledElement) {
    const images = cornerstone.getEnabledElement(enabledElement).viewport.imageIds;
    const imagemDaMesmaSerie = images.filter(image => image === metadataReferencedImageId).length > 0;
    if (imagemDaMesmaSerie)
      referencedImageId = metadataReferencedImageId;
  }
}

function retornarFocoNaPrimeiraSerie() {
  //const dataReferencedImageId = medidas[0].metadata.referencedImageId;
  //focarNaSerie(dataReferencedImageId);
  const displaySetInstanceUID = services.displaySetService.activeDisplaySets[0].displaySetInstanceUID;
  services.viewportGridService.setDisplaySetsForViewports(services.hangingProtocolService.getViewportsRequireUpdate(0, displaySetInstanceUID));
  startProgressBar(false);
}

function focarNaSerie(referencedImageId) {
  try {
    const displaySets = services.displaySetService.activeDisplaySets;
    const activeDisplaySet = displaySets.filter(obj => obj.images[0].imageId === referencedImageId);
    if (activeDisplaySet.length > 0) {
      const activeViewportIndex = services.viewportGridService.getState().activeViewportIndex;
      const displaySetInstanceUID = activeDisplaySet[0].displaySetInstanceUID;
      services.viewportGridService.setDisplaySetsForViewports(services.hangingProtocolService.getViewportsRequireUpdate(activeViewportIndex, displaySetInstanceUID));
    }
  } catch (ex) {
    console.log(ex);
  }
}

function aguardarCarregamentoDaSerie(medida, dataReferencedImageId) {
  const currentTimeout = setInterval(() => {
    try {
      const viewportIdCompare = cornerstone.getEnabledElements()[0].viewportId;
      const viewPortIdEnabled = viewportIdCompare === viewPortId;
      if (viewPortIdEnabled) {
        clearInterval(currentTimeout);
        referencedImageId = dataReferencedImageId;
        countMedida++;
        addAnnotation(medida);
      } else {
        viewPortId = viewportIdCompare;
      }
    } catch (ex) { }
  }, 500);
}
